import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getCompany(){
  return request({
    url: "/api/companys",
    method: "get"
  });
}

export function createCompany(data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/companys",
    method: "post",
    data: data
  });
}

export function getCompanyBy(uid){
  return request({
    url: "/api/companys/" + uid,
    method: "get"
  });
}

export function updateCompany(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: "/api/companys/" + uid,
    method: "put",
    data: data
  });
}

export function delCompany(uid){
  return request({
    url: "/api/companys/" + uid,
    method: "delete",
    data: {idempotency:uuid.v1()}
  });
}